import {
  AutoComplete,
  FormContainer,
  ISelectType,
  SwitchInput,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IMarComAutomationCategoryProps } from "./models";
import { categoriesSchema, TCategoriesForm } from "./categoriesSchema";
import {
  createMarComAutomationCategory,
  getMarComAutomationCategoryById,
  updateMarComAutomationCategory,
} from "../../../../../../services/marComAutomationCategories.service";
import { listCategoriesByProfileAccess } from "../../../../../../services/listProfileAccess.service";

const translationPath = "page.4uMarCom.automationRules.marcom_categories.";

export const Categories = memo(
  ({
    id,
    marComAutomationRuleId,
    onBackButton,
  }: IMarComAutomationCategoryProps) => {
    const { t } = useTranslation();

    const { sendRequest: save, loading: sLoading } = useFetch(
      createMarComAutomationCategory
    );

    const { sendRequest: update, loading: uLoading } = useFetch(
      updateMarComAutomationCategory
    );

    const { sendRequest: get, loading: gLoading } = useFetch(
      getMarComAutomationCategoryById
    );

    const updateHandler = (v: TCategoriesForm, id: string) =>
      update({
        item: {
          id: id,
          marComAutomationRuleId: marComAutomationRuleId ?? "",
          listCategoryId: v.listCategory.id,
        },
        id: id,
      });

    const saveHandler = (v: TCategoriesForm) =>
      save({
        marComAutomationRuleId: marComAutomationRuleId ?? "",
        listCategoryId: v.listCategory.id,
      });

    const getHandler = useCallback(
      async (id: string): Promise<Treturn<TCategoriesForm>> => {
        const { data, success } = await get(id);

        if (data) {
          const newData: TCategoriesForm = {
            ...data,
            listCategory: data.listCategory,
          };
          return { data: newData, success: true };
        }
        return { data, success };
      },
      [get]
    );
    const successHandle = () => {
      onBackButton();
    };
    const loading = sLoading || uLoading || gLoading;
    return (
      <FormContainer<TCategoriesForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        loading={loading}
        title={t(translationPath + "title")}
        schema={categoriesSchema}
        subtitle={t(translationPath + "new")}
        backButtonOnClick={onBackButton}
        redirectOnSave={false}
        onSuccess={successHandle}
        isModalForm={true}
        propId={id}
        formActionsOnBottom={false}
        fields={() => (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <AutoComplete
                getOptionLabel={({ name }) => name}
                size="small"
                label={t(translationPath + "list_category")}
                name="listCategory"
                request={listCategoriesByProfileAccess}
                clearIcon={false}
              />
            </Grid>
          </Grid>
        )}
      />
    );
  }
);
